import React, { useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { Button } from "react-bootstrap";
import Contract from "domain/contract";
import useStartup from "common/ui/useStartup";
import contractService from "./contractService";
import Permissions from "common/security/permissions";
import usePermission from "common/security/usePermission";

export type SyncContractToErpRetryModalProps = {
    showModal: boolean;
    contract: Contract;
    handleCancel(show: boolean): any;
    retryErpSync(contract: Contract): any;
};

const SyncContractToErpRetryModal: React.FC<SyncContractToErpRetryModalProps> = (props: SyncContractToErpRetryModalProps) => {
    const canRetrySync = usePermission(Permissions.RetrySync);

    const [failureReason, setFailureReason] = useState<string>(null);

    useStartup(() => {
        contractService.getErpSyncFailureReason(props.contract.id).then(m => setFailureReason(m));
    });

    function onClose() {
        props.handleCancel(false);
    }

    return (      
        <Modal show={props.showModal} onHide={onClose} backdrop="static" >
            <Modal.Header closeButton>
                <Modal.Title>
                    ERP Contract Sync Errors
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="sync-retry-modal">
                <div className="inline">
                    {failureReason}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="pull-right">
                    <Button variant="secondary" className="ml-2" onClick={onClose}>
                        Cancel
                    </Button>&nbsp;
                    {canRetrySync && <Button variant="primary" onClick={() => props.retryErpSync(props.contract)}>
                        Retry Sync
                    </Button>}
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default SyncContractToErpRetryModal;